//import { ParkingDetails } from "../ViewModels/ParkingDetailsViewModel"
import GetDftConnectivityToolScoreViewModel from "./GetDftConnectivityToolScoreViewModel";
export default class SiteViewModel {
    index: number = 0;

    // --< Location Details >-- 
    reference?: string | null = '';
    releaseVersion?: number | null = null;
    previousReSurveyReference?: string | null = '';
    nextReSurveyReference?: string | null = '';
    surveyType?: string | null = '';
    area?: string | null = '';
    region?: string | null = '';
    description?: string | null = '';
    descriptions?: string[] | null = [];
    landUse?: string | null

    street?: string | null = '';
    district?: string | null = '';
    city?: string | null = '';
    postcode?: string | null = '';
    planningAuthority?: string | null = '';
    latitude: number | null = null;
    longitude: number | null = null;
    location: number | null = 0;
    locnSubCategory: number | null = 0;
    useClass: number | null = null;
    param1Label: string = '';
    param1Abbreviation: string = '';
    param1Unit: string = '';
    param1Value: number | null = null;
    param2Label: string = '';
    param2Abbreviation: string = '';
    param2Unit: string = '';
    param2Value: number | null = null;
    param3Label: string = '';
    param3Value: number | null = null;
    param4Label: string = '';
    param4Value: number | null = null;
    numberOfDevelopments: number | null = null;
    numberOfSurveyDays: number | null = null;
    version?: string | null = '';
    dateCreated?: string | null = '';
    mostRecentSurveyDateInt: number = 0;
    isDftConnectivityToolEligible: boolean = false;
    isDftConnectivityToolEnabled: boolean = false;
    travelPlan?: string | null = '';
    isTravelPlanInFuture?: string | null = '';
    isDataAvailablePriorToTravelPlan?: string | null = '';
    isUrbanRegeneration?: string | null = '';
    isSAM?: string | null = '';
    isCovid19?: string | null = '';
    comments?: string | null = '';
    oneMilePopulation: number | null = null;
    fiveMilePopulation: number | null = null;
    population500m: number | null = null;
    carOwnershipFiveMiles: number | null = null;
    hillyOrFlat: number | null = null
    numberOfEmployees: number | null = null
    fullTimeEmployees: number | null = null
    partTimeEmployees: number | null = null

    ptalRating: string | null = null;
    sixthFormOnSite: string | null = '';
    nurseryOnSite: string | null = '';


    //Local Traffic Calming Features
    speedLimit: number | null = null;
    speedBumps: boolean | null = null;
    speedCameras: boolean | null = null;
    giveWayRestirctions: boolean | null = null;
    stoppingRestrictions: boolean | null = null;
    widthRestrictions: boolean | null = null;
    busLanes: boolean | null = null;
    mphRoads: boolean | null = null;

    siteOffices: string | null = null;
    siteResearchAndDev: string | null = null;
    siteLightIndustrial: string | null = null;
    siteGeneralIndustrial: string | null = null;
    siteStorageAndDistribution: string | null = null;

    dftConnectivityToolScore: GetDftConnectivityToolScoreViewModel = new GetDftConnectivityToolScoreViewModel();

    hasMap: boolean | null = null;
    population1Mile: string | null = '';
    population5Miles: string | null = '';
    carOwner: string | null = '';

    // Census Details
    censusYear: string = '';
    analysisYear: string = '';
    primarySchoolDistance: string = '';
    secondarySchoolDistance: string = '';
    cornerShopDistance: string = '';
    supermarketDistance: string = '';
    surgeryDistance: string = '';
    hospitalDistance: string = '';
    sportsCentreDistance: string = '';
    censusOutputArea: string = '';
    numberOfHouseholdsInArea: string = '';
    numberOfPeopleInArea: string = '';
    censusArea: string = '';
    censusPopulationDensity: number | null = null;
    censusEmployed: string | null = '';

    // --< Design Features 12 - 14 >--
    pedestrianFeatures?: string | null = '';
    cycleFeatures?: string | null = '';
    publicTransportFeatures?: string | null = '';

    hasParkingDetails: boolean | null = null;
    hasDevelopmentDetails: boolean | null = null;
    hasTravelPlan: boolean | null = null;
}
